/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../action';
import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../CustomMaterial';

const TrimModel = () => { 
    const dispatch = useDispatch();   
    const [frontWallCloseSize, setFrontWallCloseSize] = useState(0);
    const [backWallCloseSize, setBackWallCloseSize] = useState(0);
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);
    const [sideWallLeftPorchSize, setSideWallLeftPorchSize] = useState(0);
    const [sideWallRightPorchSize, setSideWallRightPorchSize] = useState(0);
    const [offSetHeight, setOffSetHeight] = useState(0)

    const sideJTrimState = (params.p_j_t && params.p_b_c_b_f_l !== "Open" && params.p_b_c_b_f_l !== "Close");
    const frontJTrimState = (params.p_j_t_end && params.p_b_c_b_f_f !== "Open" && params.p_b_c_b_f_f !== "Close"  && params.p_b_c_b_f_f !== "Half Dutch End" && params.p_b_c_b_f_f !== "Half End");
    const backJTrimState = (params.p_j_t_end && params.p_b_c_b_f_b !== "Open" && params.p_b_c_b_f_b !== "Close" && params.p_b_c_b_f_b !== "Half Dutch End" && params.p_b_c_b_f_b !== "Half End");  

    const trimOffset = useMemo(() => {
        if(params.p_b_c_b_f_l === 'Open') return 0;
        else return 0.2;
    }, [params.p_b_c_b_f_l])

    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation === "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const frontWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();        

        if (!(params.p_b_c_b_f_f === "Open" || params.p_b_c_b_f_f === "Gable" || params.add_right_front_lean_porch || params.p_b_c_b_f_l === 'Close')) {
            model.moveTo((params.leanF_p_d / 2 + 0.075), frontWallCloseSize);
            model.lineTo((params.leanF_p_d / 2 + 0.075), params.leanF_p_h + offSetHeight);
            model.lineTo((params.leanF_p_d / 2 - 0.08), params.leanF_p_h + offSetHeight);
            model.lineTo((params.leanF_p_d / 2 - 0.08), frontWallCloseSize);
            model.closePath();
        } else if (params.add_right_front_lean_porch && (frontWallCloseSize < sideWallCloseSize)) {
            model.moveTo((params.leanF_p_d / 2 + 0.075), frontWallCloseSize);
            model.lineTo((params.leanF_p_d / 2 + 0.075), sideWallCloseSize);
            model.lineTo((params.leanF_p_d / 2 - 0.08), sideWallCloseSize);
            model.lineTo((params.leanF_p_d / 2 - 0.08), frontWallCloseSize);
            model.closePath();
        }

        return model;
    }, [frontWallCloseSize, sideWallCloseSize, params.p_b_c_b_f_f, params.add_right_front_lean_porch, params.leanF_p_h, params.leanF_p_d, offSetHeight, params.p_b_c_b_f_l])

    const dutchDelModelFront = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.leanF_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanF_p_h - ((params.b_l_t_r_pF / 12) * params.leanF_p_w) :  params.leanF_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_front_lean && (params.p_b_c_b_f_f === "Half Dutch End" || params.p_b_c_b_f_f === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanF_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_f_f === "Half Dutch End") {
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.leanF_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_front_lean, params.leanF_p_w, params.leanF_p_h, params.p_b_c_b_f_f])


    const dutchDelModelBack = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        let cornerFreeSpaceW = (params.leanF_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanF_p_h - ((params.b_l_t_r_pF / 12) * params.leanF_p_w) :  params.leanF_p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_front_lean && (params.p_b_c_b_f_b === "Half Dutch End" || params.p_b_c_b_f_b === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.leanF_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_f_b === "Half Dutch End") {
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.leanF_p_w / 2 - freeSpace), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.leanF_p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.leanF_p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.add_front_lean, params.leanF_p_w, params.leanF_p_h, params.p_b_c_b_f_b])


    const backWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_b === "Open" || params.p_b_c_b_f_b === "Gable" || params.add_left_front_lean_porch || params.p_b_c_b_f_l === 'Close')) {
            if(params.p_b_c_b_f_l !== 'Close' && params.add_left_front_lean_porch){
                model.moveTo(-(params.leanF_p_d / 2 + 0.075), backWallCloseSize);
                model.lineTo(-(params.leanF_p_d / 2 + 0.075), sideWallCloseSize);
                model.lineTo(-(params.leanF_p_d / 2 - 0.08), sideWallCloseSize);
                model.lineTo(-(params.leanF_p_d / 2 - 0.08), backWallCloseSize);
                model.closePath();
            } else {
                model.moveTo(-(params.leanF_p_d / 2 + 0.075), backWallCloseSize);
                model.lineTo(-(params.leanF_p_d / 2 + 0.075), params.leanF_p_h + offSetHeight);
                model.lineTo(-(params.leanF_p_d / 2 - 0.08), params.leanF_p_h + offSetHeight);
                model.lineTo(-(params.leanF_p_d / 2 - 0.08), backWallCloseSize);
                model.closePath();
            }
        } else if (params.add_left_front_lean_porch && (backWallCloseSize < sideWallCloseSize)) {
            model.moveTo(-(params.leanF_p_d / 2 + 0.075), backWallCloseSize);
            model.lineTo(-(params.leanF_p_d / 2 + 0.075), sideWallCloseSize);
            model.lineTo(-(params.leanF_p_d / 2 - 0.08), sideWallCloseSize);
            model.lineTo(-(params.leanF_p_d / 2 - 0.08), backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.add_storage_check_front, backWallCloseSize, params.p_b_c_b_f_b, params.add_left_front_lean_porch, params.leanF_p_h, params.leanF_p_d, offSetHeight, params.p_b_c_b_f_l, sideWallCloseSize])

    const backWallVrTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_b === "Open" || params.p_b_c_b_f_b === "Gable" || (params.add_left_front_lean_porch && !params.add_storage_check_front) || params.p_b_c_b_f_l === 'Close')) {
            model.moveTo(-(params.leanF_p_d / 2 + 0.01), 0);
            model.lineTo(-(params.leanF_p_d / 2 + 0.01), sideWallCloseSize + trimOffset - 0.1);
            model.lineTo(-(params.leanF_p_d / 2 - 0.16), sideWallCloseSize + trimOffset - 0.1);
            model.lineTo(-(params.leanF_p_d / 2 - 0.16), 0);
            model.closePath();
        }

        return model;
    }, [params.add_storage_check_front, sideWallCloseSize, params.p_b_c_b_f_b, params.add_left_front_lean_porch, params.leanF_p_h, params.leanF_p_d, offSetHeight, params.p_b_c_b_f_l,trimOffset])

    const sideWallVrLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_l === "Open")) {
            model.moveTo(-(params.leanF_p_d / 2 + sideWallLeftPorchSize + 0.075), sideWallCloseSize);
            model.lineTo(-(params.leanF_p_d / 2 + sideWallLeftPorchSize + 0.075), params.leanF_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(-(params.leanF_p_d / 2 + sideWallLeftPorchSize - 0.08), params.leanF_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo(-(params.leanF_p_d / 2 + sideWallLeftPorchSize - 0.08), sideWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanF_p_h, params.leanF_p_d, offSetHeight, sideWallCloseSize, sideWallLeftPorchSize, params.p_b_c_b_f_l])
    
    const sideWallVrRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_l === "Open")) {
            model.moveTo((params.leanF_p_d / 2 + sideWallRightPorchSize + 0.073), sideWallCloseSize);
            model.lineTo((params.leanF_p_d / 2 + sideWallRightPorchSize + 0.073), params.leanF_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo((params.leanF_p_d / 2 + sideWallRightPorchSize - 0.08), params.leanF_p_h + offSetHeight - (params.p_r_s !== 1 && 0.1));
            model.lineTo((params.leanF_p_d / 2 + sideWallRightPorchSize - 0.08), sideWallCloseSize );
            model.closePath();
        }

        return model;
    }, [params.leanF_p_h, params.leanF_p_d, offSetHeight, sideWallCloseSize, sideWallRightPorchSize, params.p_b_c_b_f_l])

    const jTrimSideModelObj = useMemo(() => {
        let main;
        let wainscot;
        
        /**********************cutting hole using CSG for side j-trim************************/
        const storageDelShape = new THREE.Shape();
            storageDelShape.moveTo(-params.leanF_p_d / 2, 0);
            storageDelShape.lineTo(-params.leanF_p_d / 2, params.leanF_p_h);
            storageDelShape.lineTo(-params.leanF_p_d / 2 + parseInt(params.add_storage_front), params.leanF_p_h)
            storageDelShape.lineTo(-params.leanF_p_d / 2 + parseInt(params.add_storage_front), 0);
            storageDelShape.closePath();

        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanF_p_d +  sideWallLeftPorchSize + sideWallRightPorchSize + 0.04)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageDelShape, extrudeSettings(0.4)))
    
        const meshStorageDelModel_Temp = meshStorageDelModel.clone();
        meshStorageDelModel_Temp.position.set(params.frontLeanStoragePosition, 0, 0);
        meshStorageDelModel_Temp.updateMatrixWorld();
    
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.rotation.y = Math.PI/ -2
        meshJTrimModel_Temp.position.set((params.leanF_p_d / 2 + sideWallRightPorchSize + 0.025), sideWallCloseSize + 0.1, 0.1475);
        meshJTrimModel_Temp.updateMatrixWorld()
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.leanF_p_pos, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
    
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshStorageDelModel_CSG = CSG.fromMesh(meshStorageDelModel_Temp)
    
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);

        let JTrimModel_CSG;
        if(params.add_storage_check_front) {
            JTrimModel_CSG = JTrimModel_CSG_Temp.subtract(meshStorageDelModel_CSG)
        } else {
            JTrimModel_CSG = JTrimModel_CSG_Temp
        }
    
        const CSGJTrimSideModel = CSG.toMesh(JTrimModel_CSG, new THREE.Matrix4())

        main = CSGJTrimSideModel.geometry

        /**********************cutting hole using CSG for side Wainscot-trim************************/
        let sideWainscotTrimRightPorchSize = (params.add_right_front_lean_porch && params.p_b_c_b_f_l === "Close") ? sideWallRightPorchSize : 0
        let sideWainscotTrimLeftPorchSize = (params.add_left_front_lean_porch && params.p_b_c_b_f_l === "Close") ? sideWallLeftPorchSize : 0

        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanF_p_d + sideWainscotTrimRightPorchSize + sideWainscotTrimLeftPorchSize + 0.07)), new THREE.MeshStandardMaterial({color: 'red'}))
    
        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/-2
        meshWainscotTrimModel_Temp.position.set((params.leanF_p_d / 2 + sideWainscotTrimRightPorchSize + 0.07), 3 , 0.14);
        meshWainscotTrimModel_Temp.updateMatrixWorld()
       
        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    
        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);

        let storageWainscotTrimModel_CSG;
        if(params.add_storage_check_front) {
            storageWainscotTrimModel_CSG = WainscotTrimModel_CSG.subtract(meshStorageDelModel_CSG)
        } else {
            storageWainscotTrimModel_CSG = WainscotTrimModel_CSG
        }
        const CSGWainscotTrimSideModel = CSG.toMesh(storageWainscotTrimModel_CSG, new THREE.Matrix4())

        wainscot = CSGWainscotTrimSideModel.geometry;

        return {main, wainscot}
        
    }, [params.leanF_p_pos, params.leanF_p_d, params.leanF_p_h, params.p_b_c_b_f_l, params.frontLeanStoragePosition, params.add_storage_check_front, params.add_storage_front, params.add_right_front_lean_porch, params.add_left_front_lean_porch, sideWallCloseSize, sideWallLeftPorchSize, sideWallRightPorchSize, const_var.newDoorsArray])

    const jTrimFrontModelObj = useMemo(() => {
        let main;
        let wainscot;
        
        /**********************cutting hole using CSG Front j-trim************************/
        const meshJTrimFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanF_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        const meshJTrimFrontModel_Temp = meshJTrimFrontModel.clone();
        meshJTrimFrontModel_Temp.position.set((params.leanF_p_d / 2 - 0.0075), frontWallCloseSize + (params.p_r_s === 1 && params.p_b_c_b_f_f === 'Gable' ? 0.36 : 0.1), -params.leanF_p_w + 0.14);
        meshJTrimFrontModel_Temp.updateMatrixWorld()

        const meshDelFrontModel_Temp = meshDelFrontModel.clone();
        meshDelFrontModel_Temp.rotation.y = Math.PI/2
        meshDelFrontModel_Temp.position.set(params.leanF_p_d/2 - 0.5, 0, - params.leanF_p_w - (params.p_d / 2));
        meshDelFrontModel_Temp.updateMatrixWorld()

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanF_p_pos, 0, -0.05);
        meshSideDelModel_Temp.updateMatrixWorld();

        const meshJTrimFrontModel_CSG = CSG.fromMesh(meshJTrimFrontModel_Temp);
        const meshDelFrontModel_CSG = CSG.fromMesh(meshDelFrontModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const JTrimFrontModel_CSG = meshJTrimFrontModel_CSG.subtract(meshDelFrontModel_CSG);
        const JtrimSideDelModel_CSG = JTrimFrontModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimFrontModel = CSG.toMesh(JtrimSideDelModel_CSG, new THREE.Matrix4())

        main = CSGJTrimFrontModel.geometry

        /**********************cutting hole using CSG for Front Wainscot-trim************************/
        const meshWainscotTrimFrontModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanF_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
    
        const meshWainscotTrimFrontModel_Temp = meshWainscotTrimFrontModel.clone();
        meshWainscotTrimFrontModel_Temp.position.set((params.leanF_p_d / 2), 3 ,-params.leanF_p_w + 0.15);
        meshWainscotTrimFrontModel_Temp.updateMatrixWorld()
    
        const meshWainscotTrimFrontModel_CSG = CSG.fromMesh(meshWainscotTrimFrontModel_Temp);
    
        const wainscotTrimFrontModel_CSG = meshWainscotTrimFrontModel_CSG.subtract(meshDelFrontModel_CSG);
        const SideDelModel_CSG = wainscotTrimFrontModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGWainscotTrimFrontModel = CSG.toMesh(SideDelModel_CSG, new THREE.Matrix4())

        wainscot = CSGWainscotTrimFrontModel.geometry

        return {main, wainscot}
    }, [params.p_d, params.leanF_p_w, params.leanF_p_d, frontWallCloseSize, const_var.newDoorsArray, params.leanF_p_pos, params.p_r_s, params.p_b_c_b_f_f])
    
    const jTrimBackModelObj = useMemo(() => {
        let main;
        let wainscot;

        /**********************cutting hole using CSG Back j-trim************************/
        const meshJTrimBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanF_p_w)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        const meshJTrimBackModel_Temp = meshJTrimBackModel.clone();
        meshJTrimBackModel_Temp.rotation.y = Math.PI
        meshJTrimBackModel_Temp.position.set((params.leanF_p_d / -2 + 0.005), backWallCloseSize + (params.p_r_s === 1 && params.p_b_c_b_f_b === 'Gable' ? 0.36 : 0.1), 0.14);
        meshJTrimBackModel_Temp.updateMatrixWorld()

        const meshDelBackModel_Temp = meshDelBackModel.clone();
        meshDelBackModel_Temp.rotation.y = Math.PI/2
        meshDelBackModel_Temp.position.set(-params.leanF_p_d/2 - 0.5, 0, - params.leanF_p_w - (params.p_d/2));
        meshDelBackModel_Temp.updateMatrixWorld()

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanF_p_pos, 0, -0.05);
        meshSideDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimBackModel_CSG = CSG.fromMesh(meshJTrimBackModel_Temp);
        const meshDelBackModel_CSG = CSG.fromMesh(meshDelBackModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);

        const JTrimBackModel_CSG = meshJTrimBackModel_CSG.subtract(meshDelBackModel_CSG);
        const JTrimSideDelModel_CSG = JTrimBackModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGJTrimBackModel = CSG.toMesh(JTrimSideDelModel_CSG, new THREE.Matrix4()) 

        main = CSGJTrimBackModel.geometry

        /**********************cutting hole using CSG Back Wainscot-trim************************/
        const meshWainscotTrimBackModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanF_p_w )), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimBackModel_Temp = meshWainscotTrimBackModel.clone();
        meshWainscotTrimBackModel_Temp.rotation.y = Math.PI
        meshWainscotTrimBackModel_Temp.position.set((params.leanF_p_d / -2), 3, 0.15);
        meshWainscotTrimBackModel_Temp.updateMatrixWorld()

        const meshWainscotTrimBackModel_CSG = CSG.fromMesh(meshWainscotTrimBackModel_Temp);

        const wainscotTrimBackModel_CSG = meshWainscotTrimBackModel_CSG.subtract(meshDelBackModel_CSG);
        const SideDelModel_CSG = wainscotTrimBackModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGWainscotTrimBackModel = CSG.toMesh(SideDelModel_CSG, new THREE.Matrix4())

        wainscot = CSGWainscotTrimBackModel.geometry

        return {main, wainscot}
    }, [params.p_d, params.leanF_p_w, params.leanF_p_d, backWallCloseSize, const_var.newDoorsArray, params.leanF_p_pos, params.p_r_s, params.p_b_c_b_f_b])

    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check_front && params.frontLeanStoragePosition === params.leanF_p_d - params.add_storage_front) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_f_f === 'Open' || typeof(params.p_b_c_b_f_f) === 'object') {
                if (params.p_r_s === 1) {
                    tempWallCloseSize = params.leanF_p_h + 0.15;
                } else {
                    tempWallCloseSize = params.leanF_p_h;
                }
            } else if (params.p_b_c_b_f_f === "One_Fourth_Close") {
                tempWallCloseSize = params.leanF_p_h / 4 * 3;
            } else if (params.p_b_c_b_f_f === "Gable") {
                tempWallCloseSize = params.leanF_p_h - 0.2;
            } else if (params.p_b_c_b_f_f === "Half_Close") {
                tempWallCloseSize = params.leanF_p_h / 2;
            } else if (params.p_b_c_b_f_f === "Three_Fourth_Close") {
                tempWallCloseSize = params.leanF_p_h / 4;
            } else if (params.p_b_c_b_f_f === "Close") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_f_f === "Half End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_f_f === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setFrontWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLFrontWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_f_f, params.leanF_p_h, params.frontLeanStoragePosition, params.add_storage_front, params.leanF_p_d])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check_front && params.frontLeanStoragePosition <= 0) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_f_b === 'Open' || typeof(params.p_b_c_b_f_b) === 'object') {
                if (params.p_r_s === 1) {
                    tempWallCloseSize = params.leanR_p_h + 0.15;
                } else {
                    tempWallCloseSize = params.leanR_p_h;
                }
            } else if (params.p_b_c_b_f_b === "One_Fourth_Close") {
                tempWallCloseSize = params.leanF_p_h / 4 * 3;
            } else if (params.p_b_c_b_f_b === "Gable") {
                tempWallCloseSize = params.leanF_p_h - 0.2;
            } else if (params.p_b_c_b_f_b === "Half_Close") {
                tempWallCloseSize = params.leanF_p_h / 2;
            } else if (params.p_b_c_b_f_b === "Three_Fourth_Close") {
                tempWallCloseSize = params.leanF_p_h / 4;
            } else if (params.p_b_c_b_f_b === "Close") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_f_b === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_f_b === "Half End") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setBackWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLBackWallCloseState': tempWallCloseSize}))
    }, [params.add_storage_check_front, params.p_b_c_b_f_b, params.leanF_p_h, params.frontLeanStoragePosition])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_f_l === 'Open' || typeof(params.p_b_c_b_f_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanF_p_h + 0.15;
            } else {
                tempWallCloseSize = params.leanF_p_h;
            }
        } else if (params.p_b_c_b_f_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_l === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanF_p_h - 3 * params.p_b_c_b_f_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_f_l, params.leanF_p_h, params.p_r_s])
    
    // --- porch state
    useMemo(() => {
        if (params.add_left_front_lean_porch) {
            setSideWallLeftPorchSize(params.leanF_p_w);
        } else {
            setSideWallLeftPorchSize(0);
        }
    }, [params.add_left_front_lean_porch, params.leanF_p_w])

    useMemo(() => {
        if (params.add_right_front_lean_porch) {
            setSideWallRightPorchSize(params.leanF_p_w);
        } else {
            setSideWallRightPorchSize(0);
        }
    }, [params.add_right_front_lean_porch, params.leanF_p_w])

    useMemo(() => {
        if (params.p_r_s === 1) {
            setOffSetHeight(0.04)
        } else {
            if (sideJTrimState === true) {
                setOffSetHeight((params.p_b_c_b_f_l === 'Open') ? 0 : -0.1)
            } else if (sideJTrimState === false) {
                setOffSetHeight(0)
            }
        }
    }, [params.p_r_s, sideJTrimState, params.p_b_c_b_f_l])
    
    return (
        <>
        <group position={[0, 0, params.p_d / 2 + params.leanF_p_w + 0.01]}>
            <mesh name="front-wall-trim">
                <extrudeGeometry args={[frontWallVrTrimModel, extrudeSettings(0.225)]} />
                <MaterialTrim visibleSection={"frontLean"} />
            </mesh>
            <mesh name="back-wall-trim">
                <extrudeGeometry args={[backWallVrTrimModel, extrudeSettings(0.22)]} />
                <MaterialTrim visibleSection={"frontLean"} />
            </mesh>
            <mesh name="side-wall-left-trim" position={[0, 0, -0.01]}>
                <extrudeGeometry args={[sideWallVrLeftTrimModel, extrudeSettings(0.235)]} />
                <MaterialTrim visibleSection={"frontLean"} />
            </mesh>
            <mesh name="side-wall-right-trim">
                <extrudeGeometry args={[sideWallVrRightTrimModel, extrudeSettings(0.225)]} />
                <MaterialTrim visibleSection={"frontLean"} />
            </mesh>

            {sideJTrimState && jTrimSideModelObj.main &&
                <mesh name="side-wall-J-trim" geometry={jTrimSideModelObj.main}>
                    <MaterialTrim visibleSection={"frontLean"} />
                </mesh>
            }
            {frontJTrimState && jTrimFrontModelObj.main &&
                <mesh name="front-wall-J-trim" geometry={jTrimFrontModelObj.main}>
                    <MaterialTrim visibleSection={"frontLean"} />
                </mesh>
            }
            {backJTrimState && jTrimBackModelObj.main &&
                <mesh name="back-wall-J-trim" geometry={jTrimBackModelObj.main}>
                    <MaterialTrim visibleSection={"frontLean"} />
                </mesh>
            }

            {params.p_w_c_n === true && (params.p_b_c_b_f_l === "Close") && jTrimSideModelObj.wainscot &&
                <mesh name="wainscotTrim" geometry={jTrimSideModelObj.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"frontlean"}/>
                </mesh>
            }
            {params.p_w_c_n === true && params.p_b_c_b_f_f === "Close" && jTrimFrontModelObj.wainscot &&
                <mesh name="F_L_R_W_wainscotTrim" geometry={jTrimFrontModelObj.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"frontlean"}/>
                </mesh>
            }
            {params.p_w_c_n === true && params.p_b_c_b_f_b === "Close" && jTrimBackModelObj.wainscot &&
                <mesh name="F_L_L_W_wainscotTrim" geometry={jTrimBackModelObj.wainscot} >
                    <MaterialWainScotTrimNew   visibleSection={"frontlean"}/>
                </mesh>
            }
            {/* {params.p_w_c_n === true && params.p_b_c_b_f_b === "Close" && jTrimBackModelObj.wainscot &&
                <mesh name="wainscotTrim" geometry={jTrimBackModelObj.wainscot} >
                    <meshStandardMaterial onUpdate={(self) => {self.needsUpdate = true}} map={(params.wainscotTexture.includes("stone")) ? texture : null} color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'frontLean')} opacity={0.02} />
                </mesh>
            } */}
            {/* {params.p_w_c_n === true && params.add_storage_check_front && storageFrontWall &&
                <mesh name="wainscotTrim" geometry={storageFrontWall} position={[3 * offset / 2-0.05, 0, 0]}>
                    <meshStandardMaterial onUpdate={(self) => {self.needsUpdate = true}} map={(params.wainscotTexture.includes("stone")) ? texture : null} color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'frontLean')} opacity={0.02} />
                </mesh>
            } */}
        </group>
            <mesh rotation={[0, Math.PI / 2, 0]} position={[ params.leanF_p_d / 2 - 0.1, 0, params.leanF_p_w / 2 + params.p_d / 2]} >
                    <extrudeGeometry args={[dutchDelModelFront, extrudeSettings(0.15)]}/>
                    <MaterialTrim visibleSection={"frontLean"} />
            </mesh>
            <mesh rotation={[0, Math.PI / 2, 0]} position={[ - (params.leanF_p_d / 2 + 0.1), 0, params.leanF_p_w / 2 + params.p_d / 2]} >
                <extrudeGeometry args={[dutchDelModelBack, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"frontLean"} />
            </mesh>
        </>
    )
}

export default TrimModel